// core/stores/muteStore.ts — Zustand store for per-viewer mute state.
//
// Keyed by normalised handle (no @ prefix, lowercased) → boolean, mirroring
// followStore's shape and normalisation contract exactly.
// Services mutate this store; hooks read it reactively.

import { create } from 'zustand';
import { normHandle } from './followStore';

interface MuteStoreState {
  muted: Record<string, boolean>;

  setMuted: (handle: string, muted: boolean) => void;

  // Replace the entire mute map (used by hydrate() at boot and _resetForTest).
  setMutes: (muted: Record<string, boolean>) => void;
}

export const useMuteStore = create<MuteStoreState>()((set) => ({
  muted: {},

  setMuted: (handle, muted) =>
    set((s) => {
      const key = normHandle(handle);
      if (muted) {
        return { muted: { ...s.muted, [key]: true } };
      }
      const next = { ...s.muted };
      delete next[key];
      return { muted: next };
    }),

  setMutes: (muted) => set({ muted }),
}));
